import './App.css';
import  React from 'react';
import { CubeCo2 } from './views/cubeco2';

export function App():any {
  return <CubeCo2/>;
}

export default App;